import { CSSProperties } from "react"

export const RESCHEDULED_EVENT_STRIPE_PATTERN = 'repeating-linear-gradient(45deg, transparent 0, transparent 6px, rgba(255, 255, 255, 0.15) 6px, rgba(255, 255, 255, 0.15) 12px)'

export const HOVER_POPOVER_OVERLAY_STYLE: CSSProperties = { pointerEvents: 'none' }
